import { education, training } from "../data";
import { Reveal, Section, TagList } from "./ui";

export function Education() {
  return (
    <Section
      id="education"
      title="Education"
      intro="Two qualifications, one thread: computers, and how to build with them."
    >
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr] lg:gap-16">
        <ol className="space-y-5">
          {education.map((item, index) => (
            <li key={item.qualification}>
              <Reveal delay={index * 0.08}>
                <div className="glass leaf p-7 sm:p-8">
                  <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
                    <h3 className="text-display max-w-[26ch] text-[1.3rem] leading-tight text-porcelain">
                      {item.qualification}
                    </h3>
                    <span className="text-[0.8rem] text-faint">{item.period}</span>
                  </div>
                  <p className="mt-2 text-[0.92rem] text-orchid/90">{item.org}</p>
                  <p className="mt-1 text-[0.82rem] text-faint">
                    {item.place} · {item.note}
                  </p>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>

        <div>
          <Reveal delay={0.16}>
            <p className="text-display text-[1.15rem] text-porcelain">Additional training</p>
          </Reveal>
          {training.map((item, index) => (
            <Reveal key={item.title} delay={0.2 + index * 0.08}>
              <div className="glass halo-azure leaf-bl mt-5 p-7">
                <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
                  <h3 className="text-display text-[1.15rem] text-porcelain">{item.title}</h3>
                  <span className="text-[0.78rem] text-faint">{item.period}</span>
                </div>
                <p className="mt-2 text-[0.88rem] text-orchid/90">{item.org}</p>
                <p className="mt-4 leading-relaxed text-mist">{item.description}</p>
                <TagList items={item.tags} className="mt-5" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
